import {
  LongTextField,
  ReferenceListField,
  useFieldLabel,
  useMakeRedirect,
} from "ra-friendsofbabba";

import { DateField } from "react-admin";
import DeleteButton from "../buttons/DeleteButton";
import DownloadButton from "../../component/button/DownloadButton";
import FilenameField from "./FilenameField";
import React from "react";
import useFormPermission from "../useFormPermission";

const ProjectDocsField = ({ tab = 4, ...props }) => {
  const fieldLabel = useFieldLabel({ resource: "project-docs" });
  const hasFormPermission = useFormPermission();
  const disabled = !hasFormPermission(props.source);
  const makeRedirect = useMakeRedirect({
    resource: "projects",
    record: props.record,
    tab: 4,
  });
  return (
    <ReferenceListField
      {...props}
      tab={tab}
      reference="project-docs"
      target="project_id"
      sort={{
        field: "created",
        order: "DESC",
      }}
      addLabel={false}
      createLabel="ra.action.add_project_docs"
      create={!props.disabled && !disabled}
      modify={false}
      remove={false}
    >
      <FilenameField
        disabled={disabled}
        source="media.filename"
        label="app.filename"
      />
      <LongTextField
        source="project_doc_type_name"
        label={fieldLabel("project_doc_type_id")}
        variant="body2"
      />
      <DateField source="created" showTime />
      <DownloadButton />

      <DeleteButton
        disabled={props.disabled || disabled}
        confirmContent={(record, translate) =>
          translate("ra.messages.confirm_file_delete", {
            filename: record.media.filename,
          })
        }
        redirect={makeRedirect}
      />
    </ReferenceListField>
  );
};

export default ProjectDocsField;
